import React from "react";
import {
  Row,
  Col,
  Breadcrumb,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation/Navigation";
import Footer from "./Footer/Footer";
import * as Icon from "react-feather";
import firebase from "../Utils/Firebase";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.min.css";
import User from "../model/User";
import styled from "styled-components";
class Referral extends React.Component {
  state = {
    sideMenu: true,
    referral: User.getInstance().selectedReferral,
    status: User.getInstance().selectedReferral.status,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    if (!User.getInstance().selectedReferral) {
      window.location.href = "/";
    }
  }

  // Toggle side bar menu
  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  async changeStatus(status) {
    await firebase
      .firestore()
      .collection("referrals")
      .doc(User.getInstance().selectedReferralId)
      .update({ status: status })
      .then(async (result) => {
        await this.notifyUser(this.state.referral.uid, status);
      });
  }

  async notifyUser(uid, status) {
    await firebase
      .firestore()
      .collection("salons")
      .doc(uid)
      .get()
      .then(async (snapshot) => {
        if (snapshot) {
          if (snapshot.data()) {
            let pushToken = snapshot.data().pushToken;
            let referralNotifications = snapshot.data().referralNotifications;
            let allowNotifications = snapshot.data().allowNotifications;

            if (
              referralNotifications === false ||
              allowNotifications === false ||
              pushToken === null
            ) {
              alert("User Has Not enabled the referral notifications feature");
              window.location.reload();
            } else {
              if (pushToken) {
                await this.sendNotification(pushToken, status);
              }
            }
          }
        }
      });

    await firebase
      .firestore()
      .collection("customers")
      .doc(uid)
      .get()
      .then(async (snapshot) => {
        if (snapshot) {
          if (snapshot.data()) {
            let pushToken = snapshot.data().pushToken;
            let referralNotifications = snapshot.data().referralNotifications;
            let allowNotifications = snapshot.data().allowNotifications;

            if (
              referralNotifications === false ||
              allowNotifications === false ||
              pushToken === null
            ) {
              alert("User Has Not enabled the referral notifications feature");
              window.location.reload();
            } else {
              if (pushToken) {
                await this.sendNotification(pushToken, status);
              }
            }
          }
        }
      });
  }

  async sendNotification(pushToken, status) {
    let data = {
      title: "Trim-Direct",
      body: "The Status of your referral has been updated to " + status + "!",
      pushToken,
    };
    var sender = firebase.functions().httpsCallable("sendNotificationToUser");
    sender(data)
      .then((result) => {
        alert("The user has been notified successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        alert("There was an error notifying the user!");
        window.location.reload();
      });
  }

  render() {
    return (
      <div className="page-wrapper">
        <Icon.ArrowRight id="arrowIcon" className="icon" />
        {/* Navigation */}
        <Navigation onClick={this._onSideMenu} />
        {/* End Navigation */}

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          {/* Breadcrumb */}
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Referral</h1>
              <Link to="/dashboard" className="breadcrumb-item">
                Dashboard
              </Link>
              <Breadcrumb.Item active>Referral</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Row>
            <Col lg={12}>
              <div className="profile-header mb-4">
                <h1 className="name mt-3">{this.state.referral.shopName}</h1>
              </div>
            </Col>

            <Col lg="3">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Info</h5>
                    </div>
                    <ul className="info">
                      <li>
                        <Icon.MapPin className="icon" />
                        Sender Name: {this.state.referral.senderName + ""}
                      </li>
                      <li>
                        <Icon.MapPin className="icon" />
                        Sender User Id: {this.state.referral.uid + ""}
                      </li>
                      <li>
                        <Icon.User className="icon" />
                        Sender Account Number:
                        {this.state.referral.senderAccountNumber + ""}
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        Sender Sort Code:{" "}
                        {this.state.referral.senderSortCode + ""}
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        Shop Name: {this.state.referral.shopName + ""}
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        Shop Address: {this.state.referral.shopAddress + ""}
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        Barber Name: {this.state.referral.barberName + ""}
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        Barber Number: {this.state.referral.barberNumber + ""}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="3">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Actions</h5>
                    </div>
                    <div>
                      <DropdownButton
                        id="dropdown-basic-button"
                        title={this.state.status}
                        variant={
                          this.state.status === "Listed" ? "success" : "danger"
                        }
                      >
                        <Dropdown.Item
                          onClick={() => this.changeStatus("Listed")}
                        >
                          Listed
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => this.changeStatus("In Progress")}
                        >
                          In Progress
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => this.changeStatus("Rejected")}
                        >
                          Rejected
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="flex-grow-1" />
          <Footer />
        </div>
      </div>
    );
  }
}

export const dateConverter = (UNIX_timestamp) => {
  var a = new Date(UNIX_timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + " " + month + " " + year;
  return time;
};

export default Referral;

const TitleInput = styled.input``;
const BodyInput = styled.textarea``;
const SendButton = styled.button``;
const Label = styled.h3`
  margin-right: 16px;
`;
